<script setup lang="ts">
const { open, isNotTransparent } = defineProps<{ open: boolean; isNotTransparent?: boolean }>();
</script>

<template>
  <div class="app-loader" v-if="open" :class="{ 'not-transparent': isNotTransparent }">
    <div class="loader-content">
      <ion-spinner name="crescent" color="primary" class="size-[80px]" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/scss/setup/_functions.scss';

.app-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #2020204d;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .loader-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  :deep(.loading-wrapper.sc-ion-loading-md) {
    box-shadow: none;
  }

  :deep(ion-spinner) {
    height: toRem(80px);
    width: toRem(80px);
  }

  &.not-transparent {
    background-color: #202020;
  }
}
</style>
